import classNames from 'clsx';
import React from 'react';
import {PdfViewerConsumer, PdfViewerProvider} from './hooks';
import {Sidebar} from './sidebar';
import ReactTooltip from 'react-tooltip';
import {Preview} from './preview';
import {DownloadIcon} from "./thumbnail-item/download";

import styles from './pdf-viewer.module.scss';

export const PdfViewer = props => {
  const {elements, onDownloadDocuments} = props;

  return (
    <>
      <ReactTooltip
        id="downloadTooltip"
        type="info"
        effect="solid"
        textColor="var(--primary)"
        border
        borderColor="var(--primary)"
        backgroundColor="white">
        Descargar
      </ReactTooltip>

      <PdfViewerProvider elements={elements}>
        <div className="flex flex-col h-full w-full border-b">
          <div className="p-4 bg-gray-50 flex justify-between items-center">
            <span>DOCUMENTOS ({elements?.length || 0})</span>
            <DownloadIcon
              data-tip data-for="downloadTooltip"
              className="cursor-pointer focus:outline-none"
              onClick={onDownloadDocuments}/>
          </div>
          <div className={classNames(styles.container)}>
            <Sidebar/>
            <div className="bg-gray-300 flex-1">
              <PdfViewerConsumer>
                {
                  state => <Preview url={state.elementSelected?.url}/>
                }
              </PdfViewerConsumer>
            </div>
          </div>
        </div>
      </PdfViewerProvider>
    </>
  );
};
